import { render, staticRenderFns } from "./SocketOnOff.vue?vue&type=template&id=5e9086b0&scoped=true"
import script from "./SocketOnOff.vue?vue&type=script&lang=js"
export * from "./SocketOnOff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9086b0",
  null
  
)

export default component.exports